
import createIconComponent from '../utils/createIconComponent';
import { SVG_SPACES_FILLED } from '../../../dist';
import React from 'react';
const SpacesFilledIcon = createIconComponent({ content: SVG_SPACES_FILLED, height: 24, width: 24 });
SpacesFilledIcon.displayName = 'SpacesFilledIcon';
export default SpacesFilledIcon;
